export interface Client {
  clientId: string;
  identificationType: string;
  identificationNumber: string;
  company: string;
  contactName: string;
  contactEmail: string;
  contactPhone: number;
  billingEmail: string;
  isSameEmail: boolean;
}

export interface CreateClientRequest {
  clientId: string;
  identificationType: string;
  identificationNumber: string;
  company: string;
  contactName: string;
  contactEmail: string;
  contactPhone: number;
  billingEmail: string;
  isSameEmail: boolean;
}

export interface UpdateClientRequest {
  clientId: string;
  identificationType: string;
  identificationNumber: string;
  company: string;
  contactName: string;
  contactEmail: string;
  contactPhone: number;
  billingEmail: string;
  isSameEmail: boolean;
}

export interface ClientList {
  clientId: string;
  company: string;
}

export function ClientActions() {
  function clientInfo(
    clientId: string,
    identificationType: string,
    identificationNumber: string,
    company: string,
    contactName: string,
    contactEmail: string,
    contactPhone: number,
    billingEmail: string,
    isSameEmail: boolean
  ): Client {
    return {
      clientId: clientId,
      identificationType: identificationType,
      identificationNumber: identificationNumber,
      company: company,
      contactName: contactName,
      contactEmail: contactEmail,
      contactPhone: contactPhone,
      billingEmail: billingEmail,
      isSameEmail: isSameEmail,
    };
  }

  function clientList(
    clientId: string,
    company: string,
  ): ClientList {
    return {
      clientId: clientId,
      company: company,
    };
  }

  function createClientRequest(
    clientId: string,
    identificationType: string,
    identificationNumber: string,
    company: string,
    contactName: string,
    contactEmail: string,
    contactPhone: number,
    billingEmail: string,
    isSameEmail: boolean,
  ): CreateClientRequest {
    return {
      clientId: clientId,
      identificationType: identificationType,
      identificationNumber: identificationNumber,
      company: company,
      contactName: contactName,
      contactEmail: contactEmail,
      contactPhone: contactPhone,
      billingEmail: billingEmail,
      isSameEmail: isSameEmail,
    };
  }

  function updateClientRequest(
    clientId: string,
    identificationType: string,
    identificationNumber: string,
    company: string,
    contactName: string,
    contactEmail: string,
    contactPhone: number,
    billingEmail: string,
    isSameEmail: boolean,
  ): UpdateClientRequest {
    return {
      clientId: clientId,
      identificationType: identificationType,
      identificationNumber: identificationNumber,
      company: company,
      contactName: contactName,
      contactEmail: contactEmail,
      contactPhone: contactPhone,
      billingEmail: billingEmail,
      isSameEmail: isSameEmail,
    };
  }

  function deserialize(object: string): Client[] {
    const parseResponse = JSON.parse(JSON.stringify(object));
    return parseResponse.map((client: Client) => {
      return clientInfo(
        client.clientId,
        client.identificationType,
        client.identificationNumber,
        client.company,
        client.contactName,
        client.contactEmail,
        client.contactPhone,
        client.billingEmail,
        client.isSameEmail
      );
    });
  }

  function deserializeObject(object: string): Client {
    const parseResponse = JSON.parse(JSON.stringify(object));
    return clientInfo(
      parseResponse.clientId,
      parseResponse.identificationType,
      parseResponse.identificationNumber,
      parseResponse.company,
      parseResponse.contactName,
      parseResponse.contactEmail,
      parseResponse.contactPhone,
      parseResponse.billingEmail,
      parseResponse.isSameEmail
    );
  }

  return {
    clientInfo,
    clientList,
    createClientRequest,
    updateClientRequest,
    deserialize,
    deserializeObject,
  };
}
